<div class="heatmap" [class.is-loading]="loading">
	<div class="week-labels">
		<span aria-hidden="true">Mon</span>
		<span aria-hidden="true"></span>
		<span aria-hidden="true">Wed</span>
		<span aria-hidden="true"></span>
		<span aria-hidden="true">Fri</span>
		<span aria-hidden="true"></span>
		<span aria-hidden="true"></span>
	</div>
	<div class="months" role="group" aria-label="Last 12 months attendance">
		<div class="month" *ngFor="let m of months">
		<div class="month-label">{{ m.label }}</div>
		<div class="month-grid" [style.--week-count]="m.weeks.length">
			<ng-container *ngFor="let week of m.weeks">
				<i *ngFor="let d of week" class="day" [class.in-month]="d.isCurrentMonth" [class.active]="d.isActive" [class.today]="d.isToday" [attr.title]="d.details" [style.backgroundColor]="d.backgroundColour"></i>
			</ng-container>
		</div>
		</div>
	</div>
</div>